export enum ToastMessageType {
    info,
    warning,
    error,
    success
}